import React from 'react';
import Header from './Header';
import Information from './Information';
import Table from './Table';
import Summary from './Summary';
import Signature from './Signature';
import TNC from './TNC';
import { getPropsFromObject } from '../../utils';

const getHeaderData = getPropsFromObject('Shop', 'Header2', 'Address', 'Tel', 'Fax');
const getInformationData = getPropsFromObject('MemberName', 'MemberCode', 'Invoicenumber', 'Invoicedate');
const getLessonData = getPropsFromObject('Items', 'Depositpayment');
const getPaymentData = getPropsFromObject('Totalamount', 'Payment', 'TotalPaid', 'Depositpayment');
const getSignatureData = getPropsFromObject('Signature', 'SignatureTime');
const getTNCData = getPropsFromObject('Address', 'Invoicedate');

const Agreement2 = props => {
  const { agreement } = props;
  const headerData = getHeaderData(agreement);
  const informationData = getInformationData(agreement);
  const lessonsData = getLessonData(agreement);
  const paymentsData = getPaymentData(agreement);
  const signatureData = getSignatureData(agreement);
  const tncData = getTNCData(agreement);

  return (
    <div className={"agreement"}>
      <Header header={headerData} />
      <hr className={"separator"} />
      <Information information={informationData} />
      <Table lessons={lessonsData} />
      <Summary payments={paymentsData} />
      <TNC tnc={tncData} />
      <Signature signature={signatureData} />
    </div>
  );
};

export default Agreement2;